import { TableColumn, TableConfig } from '../../../../@shared/models/table.models';

export const GEOTECHNICAL_ANALYSIS_TABLE_COLUMNS: TableColumn[] = [
    {
        field: 'reportName',
        header: 'Analysis name',
        type: 'custom',
        template: 'reportNameTemplate',
        width: '14%',
    },
    {
        field: 'projectName',
        header: 'Project name',
        type: 'custom',
        template: 'projectNameTemplate',
        width: '14%',
    },
    {
        field: 'creatorName',
        header: 'Creator name',
        type: 'custom',
        template: 'creatorNameTemplate',
        width: '14%',
    },
    {
        field: 'createdAt',
        header: 'Created date',
        type: 'custom',
        template: 'createdDateTemplate',
        width: '14%',
    },
    {
        field: 'status',
        header: 'Status',
        type: 'custom',
        template: 'statusTemplate',
        width: '10%',
    },
    {
        field: 'milestoneName',
        header: 'Milestone',
        type: 'custom',
        template: 'upcomingMilestoneTemplate',
        width: '14%',
    },
    {
        field: 'dueDate',
        header: 'Due date',
        type: 'custom',
        template: 'dueDateTemplate',
        width: '12%',
    },
    {
        field: 'actions',
        header: '',
        type: 'custom',
        template: 'actionsTemplate',
        width: '4%',
    },
];

export const GEOTECHNICAL_ANALYSIS_TABLE_CONFIG: TableConfig = {
    selectable: false,
    paginator: true,
    rows: 20,
    rowsPerPageOptions: [20, 30, 40],
    scrollable: true,
    scrollHeight: '100%',
    loading: false,
    emptyMessage: 'No geotechnical analyses found',
    globalFilter: false,
    responsive: true,
};
